module.exports = __webpack_public_path__ + "fonts/fda776bde444ea0ef0ed7b4f83dec672.jpg";